import {Component, OnInit} from '@angular/core';
import {ChartService} from "../../../tandem-core/services/chart.service";
import {FinancialPositionService} from "../../../financial-positions/services/financial-position.service";
import {CashFlowService} from "../../../cash-flows/services/cash-flow.service";
import {SpendingPlanService} from "../../../spending-plans/services/spending-plan.service";
import {AuthService} from "../../../auth/services/auth.service";
import {TandemUser} from "../../../auth/models/tandem-user";
import {FinancialPosition} from "../../../financial-positions/models/financial-position";
import {SpendingPlan} from "../../../spending-plans/models/spending-plan";
import {CashFlow} from "../../../cash-flows/models/cash-flow";
import {ThemingService} from "../../../tandem-core/services/theming.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'tandem-financial-overview',
  templateUrl: './financial-overview.component.html',
  styleUrls: ['./financial-overview.component.scss']
})
export class FinancialOverviewComponent implements OnInit {

  user: TandemUser | null = null;
  financialPosition: FinancialPosition | null = null;
  cashFlow: CashFlow | null = null;
  spendingPlan: SpendingPlan | null = null;
  fpLoaded = false;
  cfLoaded = false;
  spLoaded = false;

  chartDisplayed: 'fp' | 'cf' | 'sp' | 'all' = 'fp';
  showingDefaultFP: boolean = false;
  showingDefaultCF: boolean = false;
  showingDefaultSP: boolean = false;

  constructor(private authService: AuthService,
              private chartService: ChartService,
              private cfService: CashFlowService,
              private fpService: FinancialPositionService,
              private spService: SpendingPlanService,
              private themingService: ThemingService) {
  }

  ngOnInit(): void {
    this.authService.$user.subscribe(user => {
      if (user) {
        this.user = user;
        if (!['sm', 'md'].includes(this.themingService.getScreenSize())) {
          this.chartDisplayed = 'all';
        }
        // this.themingService.screenSize.subscribe(size => {
        //   if (!['sm', 'md'].includes(size)) {
        //     this.chartDisplayed = 'all';
        //   }
        // })
        this.fpService.getLatest(user.uid, 'positionDate').subscribe(latestPosition => {
          if (!latestPosition) {
            this.fpService.get(environment.defaultFPid).subscribe(defaultFP => {
              this.financialPosition = defaultFP;
              this.showingDefaultFP = true;
              this.fpLoaded = true;
            })
          } else {
            this.financialPosition = latestPosition;
            this.fpLoaded = true;
          }
        });
        this.cfService.getLatest(user.uid, 'startDate').subscribe(latestCashFlow => {
          if (!latestCashFlow) {
            this.cfService.get(environment.defaultCFid).subscribe(defaultCF => {
              this.cashFlow = defaultCF;
              this.showingDefaultCF = true;
              this.cfLoaded = true;
            })
          } else {
            this.cashFlow = latestCashFlow;
            this.cfLoaded = true;
          }
        });
        this.spService.getLatest(user.uid, 'startDate').subscribe(latestPlan => {
          if (!latestPlan) {
            this.spService.get(environment.defaultSPid).subscribe(defaultSP => {
              this.spendingPlan = defaultSP;
              this.showingDefaultSP = true;
              this.spLoaded = true;
            })
          } else {
            this.spendingPlan = latestPlan;
            this.spLoaded = true;
          }
        });
      }
    })
  }

  getTrackingToolNameSingular(tt: 'fp' | 'cf' | 'sp') {
    if (tt === 'fp') {
      return this.user?.customTTMetadata?.fpName || 'Financial Positions';
    } else if (tt === 'cf') {
      return this.user?.customTTMetadata?.cashFlowName || 'Cash Flows';
    } else {
      return this.user?.customTTMetadata?.spendingPlanName || 'Spending Plans';
    }
  }
}
